/**
 * Type of link
 */
type LinkType =
    | {
          type: "navigate";
          path: string;
      }
    | {
          type: "unc";
          href: string;
      }
    | {
          /**
           * Это специальный тип ссылок для файлов которые захощены нами.
           */
          type: "hosted_file";
          href: string;
          url: URL;
      }
    | { type: "external"; href: string; url: URL }
    | { type: "none" };

/**
 * Allowed origins for relative navigation
 */
const ALLOWED_ORIGINS = [
    location.hostname,
    "revolt.opencode.su",
    // "app.revolt.chat",
    // "nightly.revolt.chat",
    // "local.revolt.chat",
    // "rolt.chat",
];

/**
 * Permissible protocols in URLs
 */
const PROTOCOL_WHITELIST = [
    "http:",
    "https:",
    "ftp:",
    "ftps:",
    "mailto:",
    "news:",
    "irc:",
    "gopher:",
    "nntp:",
    "feed:",
    "telnet:",
    "mms:",
    "rtsp:",
    "svn:",
    "git:",
    "tel:",
    "fax:",
    "xmpp:",
    "magnet:",
];

const uncPathPattern = /^\\\\([^\s"'<>+?|:]+)(?:\\[^\s"'<>+?|:]+)*\\?$/i;

/**
 * Determine what kind of link we are dealing with and sanitise any malicious input
 * @param href Input URL
 * @returns Link Type
 */
export function determineLink(href?: string): LinkType {
    let internal,
        url: URL | null = null;

    if (href) {
        let decodedHref: string;
        try {
            decodedHref = decodeURIComponent(href);
        } catch (err) {
            // Malformed percent-encoding (literal % in user content, the prod
            // URIError crash) → fall back to the raw href so a UNC path with a
            // literal % still classifies as unc, and a %-URL falls through to
            // the already-guarded `new URL()` branch.
            decodedHref = href;
        }
        if (uncPathPattern.test(decodedHref)) {
            return { type: "unc", href: decodedHref };
        }

        try {
            url = new URL(href, location.href);

            if (ALLOWED_ORIGINS.includes(url.hostname)) {
                if (isFileLink(url)) {
                    return { type: "hosted_file", href, url };
                }
                const path = url.pathname.replace(/[^A-z0-9/]/g, "");
                return { type: "navigate", path };
            }
        } catch (err) {}

        if (!internal && url) {
            if (PROTOCOL_WHITELIST.includes(url.protocol)) {
                return { type: "external", href, url };
            }
        }
    }

    return { type: "none" };
}

/**
 * Функция которая проверяет является ли ссылка, ссылкой на файл
 * @param url
 */
function isFileLink(url: URL) {
    const path = url.pathname;

    const idx = path.lastIndexOf("/");
    const sliced = path.slice(idx);
    if (!sliced.includes(".")) {
        return false;
    }
    const extStarts = sliced.lastIndexOf(".");
    const ext = sliced.slice(extStarts + 1).toLowerCase();
    return !NOT_FILE_LINKS.has(ext);
}

/**
 * Здесь расширения которые содержат в себе . но обычно не являются файлами
 */
const NOT_FILE_LINKS = new Set(["php"]);
